import { ScenarioChangeRequestBase } from './base/scenario-change-request-base';

export class ScenarioChangeRequest extends ScenarioChangeRequestBase { }